import { useLanguage } from '@/hooks/useLanguage';
import './AppTour.css';

interface WelcomeTourModalProps {
  onStart: () => void;
  onSkip: () => void;
}

export function WelcomeTourModal({ onStart, onSkip }: WelcomeTourModalProps) {
  const { t } = useLanguage();

  return (
    <div
      className="app-tour-welcome-overlay"
      role="dialog"
      aria-modal="true"
      aria-label={t('appTour.welcome.title')}
    >
      <div className="app-tour-welcome-modal">
        <div className="app-tour-welcome-hero">
          <div className="app-tour-welcome-emoji" aria-hidden="true">
            ✨
          </div>
          <h1 className="app-tour-welcome-title">{t('appTour.welcome.title')}</h1>
          <p className="app-tour-welcome-subtitle">{t('appTour.welcome.subtitle')}</p>
        </div>

        <div className="app-tour-welcome-actions">
          <button type="button" className="app-tour-welcome-btn-primary" onClick={onStart}>
            {t('appTour.welcome.start')}
          </button>
          <button type="button" className="app-tour-welcome-btn-skip" onClick={onSkip}>
            {t('appTour.welcome.skip')}
          </button>
        </div>
      </div>
    </div>
  );
}
